<template>
  <v-app
    id="inspire"
    dark
  >
    <v-navigation-drawer
      v-model="drawer"
      fixed
      clipped
      app
    >
      <v-list dense>
        <v-list-tile v-on:click="" to="/">
          <v-list-tile-action>
            <v-icon>games</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Alle Spiele
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-on:click="" to="/wishlist">
          <v-list-tile-action>
            <v-icon>featured_play_list</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Meine Wunschliste
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-on:click="" to="/mygames">
          <v-list-tile-action>
            <v-icon>subscriptions</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Meine Spiele
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-on:click="logout">
          <v-list-tile-action>
            <v-icon>logout</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Logout
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      color="blue-grey"
      dense
      fixed
      clipped-left
      app
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-icon class="mx-3">fab fa-youtube</v-icon>
      <v-toolbar-title class="mr-5 align-center">
        <span class="title">Steam Giveaway</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
				<v-btn flat v-if="showLastRedemption && lastRedemptionDisplayText" class="align-center" v-on:click="showLastRedemptionSnackbar">
					{{lastRedemptionDisplayText}}
      	</v-btn>
      </v-toolbar-items>
<!--
      <v-layout row align-center style="max-width: 650px">
        <v-text-field
          :append-icon-cb="() => {}"
          placeholder="Search..."
          single-line
          append-icon="search"
          color="white"
          hide-details
        ></v-text-field>
      </v-layout>
-->
    </v-toolbar>

    <v-content>
      <v-container fill-height>
        <!-- <v-layout justify-center align-center> -->
          <!-- <v-flex shrink> -->
						<router-view></router-view>
          <!-- </v-flex> -->
        <!-- </v-layout> -->
      </v-container>
    </v-content>

    <v-snackbar
      v-model="showSnackbar"
      top
      v-bind:timeout="6000"
			v-bind:color="snackbarColor"
    >
      {{ lastRedemptionDescription }}
      <v-btn
        flat
        @click="showSnackbar = false"
      >
        Schließen
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
	import { eventBus } from "./main";

	const humanizeDuration = require("humanize-duration");
	const humanizeDurationInstance = humanizeDuration.humanizer();

	humanizeDurationInstance.languages.long = {
				y: function (c) { return 'Jahr' + (c === 1 ? '' : 'en') },
				mo: function (c) { return 'Monat' + (c === 1 ? '' : 'en') },
				w: function (c) { return 'Woche' + (c === 1 ? '' : 'n') },
				d: function (c) { return 'Tag' + (c === 1 ? '' : 'en') },
				h: function (c) { return 'Stunde' + (c === 1 ? '' : 'n') },
				m: function (c) { return 'Minute' + (c === 1 ? '' : 'n') },
				s: function (c) { return 'Sekunde' + (c === 1 ? '' : 'n') },
				ms: function (c) { return 'Millisekunde' + (c === 1 ? '' : 'n') },
				decimal: ','
	}

	humanizeDurationInstance.languages.short = {
				y: function (c) { return 'y' },
				mo: function (c) { return 'mo'},
				w: function (c) { return 'w'},
				d: function (c) { return 't'},
				h: function (c) { return 'h'},
				m: function (c) { return 'm'},
				s: function (c) { return 's'},
				ms: function (c) { return 'ms'},
				decimal: ','
	}

	export default {
    data: () => ({
			drawer: null,
			lastRedemption: null,

			showLastRedemption: false,
			intervalLastRedemption: null,
			lastRedemptionDisplayText: null,
			lastRedemptionDescription: null,

			showSnackbar: false,
			snackbarText: '',
			snackbarColor: '',
    }),

		methods: {
			logout() {
				localStorage.removeItem('u');
				this.$router.push('/login');
				this.showLastRedemption = false;
			},

			updateLastRedemptionDisplayText() {
				if (!this.lastRedemption) {
					this.lastRedemptionDisplayText = 'GO!';
					this.lastRedemptionDescription = 'Du kannst jederzeit Dein erstes Spiel freischalten, danach sind 24 Stunden abzuwarten :)';
					return;
				}

				let interval = new Date() - this.lastRedemption.toDate();

				if (interval > 1000*60*60*24) {
					this.lastRedemptionDisplayText = 'GO!';
					this.lastRedemptionDescription = 'Du kannst jetzt Dein nächstes Spiel freischalten, danach sind wieder 24 Stunden abzuwarten :)';
					return;
				}
				
				interval = 1000*60*60*24 - interval;

        this.lastRedemptionDisplayText = humanizeDurationInstance(interval, {
            round: true,
            largest: 1,
            language: 'short',
            units: ["h", "m", "s"]
					});
				
				this.lastRedemptionDescription = 'Du musst noch ca. ' + humanizeDurationInstance(interval, {
            round: true,
            largest: 1,
            language: 'long',
            units: ["h", "m", "s"]
					}) + ' warten, bis Du Dein nächstes Spiel freischalten kannst.';
			},

			showLastRedemptionSnackbar() {
				this.showSnackbar = true;
				this.snackbarColor = '';
			},
		},

		// ### Life-Cycle Hooks ###
		created() {
			if (this.$route.query.u) {
				console.log('GOT USER BY QUERY PARAM:', this.$route.query.u);
				localStorage.setItem('u', this.$route.query.u);
			};

			eventBus.$on('setLastRedemption', (redemption) => {
				this.showLastRedemption = true;
				this.lastRedemption = redemption;
			});

			this.intervalLastRedemption = setInterval(() => {
				this.updateLastRedemptionDisplayText();
			}, 1000);
		},

		beforeDestroy() {
			if (this.intervalLastRedemption) {
				clearInterval(this.intervalLastRedemption);
				
			}
		}
}
</script>
